import styled, { css } from 'styled-components';
import { tk } from '@sunwebgroup/ui-components';

type ModVariantType = 'fullWidth' | 'padded';

export default styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${tk('breakpoint_desktop_xl')};

  ${modVariant()}

  // Media queries Tablet
  @media ${tk('mq_tablet')} {
    padding: 0 ${tk('spacing_xl')};
  }

  // Media queries Desktop
  @media ${tk('mq_desktop_lg')} {
    padding: 0 ${tk('spacing_3xl')};
  }
`;

function modFullWidth() {
  return css`
    padding: 0;
  `;
}

function modPadded() {
  return css`
    padding: 0 ${tk('spacing_md')};
  `;
}

export function modVariant(variant: ModVariantType = 'padded') {
  switch (variant) {
    case 'fullWidth':
      return modFullWidth();
    default:
      return modPadded();
  }
}
